export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M17.15 1.989l-2.787.42-.275 2.091H21v2h-1.129l-1.88 13.637A1 1 0 0117 21H7a1 1 0 01-.99-.863L4.129 6.5H3v-2h9.071l.409-3.097.034-.161a1 1 0 01.807-.698l3.53-.534.298 1.979zM7.87 19h8.258l1.723-12.5h-4.028l-1.333 10.131-1.982-.261 1.3-9.87H6.147L7.871 19z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};